<template>
  <div
    class="toggle"
    :for="id"
  >
    <input
      :id="id"
      class="toggle__control"
      type="checkbox"
      :checked="value"
      @change="$emit('change', $event.target.checked)"
    >
    <label
      class="toggle__switch"
      :for="id"
    >
      <span class="toggle__handle" />
      <span class="toggle__label toggle__label--on">On</span>
      <span class="toggle__label toggle__label--off">Off</span>
    </label>
  </div>
</template>

<script>
export default {
  model: {
    event: 'change'
  },
  props: {
    type: {
      type: String,
      default: 'checkbox'
    },
    id: {
      type: String,
      default: null,
      required: true
    },
    value:{
      type: [Boolean,Number],
      default: false,
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    text: {
        type: String,
        default: "Default checkbox text"
    }
  },
};
</script>

<style lang="scss">
    @import "../../styles/shared/shared";
    $toggle-height: 1.5rem;
    $toggle-width: $toggle-height*2;
    $toggle-border-width: 1px;
    $toggle-border-color: $pigeon;
    $toggle-font-size: .6875rem;
    $toggle-line-height: $line-height-base;
    .toggle {
        position: relative;
        border: $toggle-border-width solid $toggle-border-color;
        border-radius: $toggle-width;
        width: $toggle-width;
        overflow: hidden;
        cursor: pointer;
        &__control {
            opacity: 0;
            position: absolute;
            width: 100%;
            height: $toggle-height;
            cursor: inherit;
        }
        &__switch {
            display: flex;
            background: $white;
            transition: background 150ms linear;
            margin-bottom: 0;
            cursor: inherit;
        }
        &__control:checked + &__switch {
            background: $primary;
        }
        &__handle {
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            margin-left: -$toggle-border-width;
            border-radius: 50%;
            width: $toggle-width/2;
            height: $toggle-height;
            background: $white;
            content: ' ';
            transition: margin 150ms linear;
            border: $toggle-border-width solid $toggle-border-color;
            pointer-events: none;
        }
        &__control:checked + &__switch &__handle {
            margin-left: calc((#{$toggle-width}/2) - #{$toggle-border-width});
        }
        &__label {
            flex: 1 1 50%;
            line-height: $toggle-height;
            text-align: center;
            font-weight: 400;
            font-size: $toggle-font-size;
            cursor: inherit;
            &--on { left: 0; }
            &--off { right: 0; }
        }

        &__control:checked + &__switch &__label--on{
            color: $white;
        }
        &__control + &__switch &__label--off {
            color: $tangaroa;
        }
    }
</style>
